export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS";
export const API_ERROR = "LOGIN_API_ERROR";

export const SOCIAL_LOGIN = "SOCIAL_LOGIN";

export const RESET_LOGIN_FLAG = "RESET_LOGIN_FLAG";

export const RENEW_TOKEN = "RENEW_TOKEN";
export const RENEW_TOKEN_SUCCESS = "RENEW_TOKEN_SUCCESS";
export const RENEW_TOKEN_ERROR = "RENEW_TOKEN_ERROR";

// User Online Status
export const USER_ONLINE_STATUS = "USER_ONLINE_STATUS";
export const USER_ONLINE_STATUS_SUCCESS = "USER_ONLINE_STATUS_SUCCESS";
export const USER_ONLINE_STATUS_ERROR = "USER_ONLINE_STATUS_ERROR";
